var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('favoritesService', ['$http', function ($http) {
    return {
        getUserFavoriteItems: function (userId) {
            return $http.get('favorites/getfavoriteitemsbyuserid?userId=' + userId + '&t' + Date.now());
        },
        deleteItemFromFavorites: function (prodId, userId, grpName) {
            return $http.post('favorites/deleteitemfromfavorites', { UserId: userId, SKU: prodId, GroupName: grpName });
        },
        addItemToFavorites: function (prodId, userId, grpName) {
            var response= $http.post('favorites/additemtofavorites', { userId: userId, SKU: prodId, GroupName: grpName });
             if(response && typeof gtag !== 'undefined' && gtag !== null){
                gtag("event", "add_to_wishlist", {
                    items: [
                        {
                            item_id: prodId
                        }
                    ]
                });
            }
            return response;
        },
        addBrandToFavorites: function (userId, brandName) {
            return $http.post('favorites/addbrandtofavorites', { FK_UserId: userId, BrandName: brandName });
        },
        removeBrandFromFavorites: function (userId, brandName) {
            return $http.post('favorites/deletebrandfromfavorites', { FK_UserId: userId, BrandName: brandName });
        },
        getFavoriteBrands: function (userId) {
            return $http.get('favorites/getfavoritebrandsbyuserid?userId=' + userId + '&t' + Date.now());
        },
        getFavoritegroups: function (userId) {
            return $http.get('favorites/getfavoritegroupsbyuserid?userId=' + userId + '&t' + Date.now());
        },
        createFavoritesGroup: function (favoritesGroup) {
            return $http.post('favorites/additemtofavorites', favoritesGroup);
        },
        updateItemsFavoritesGroup: function (favoritesGroup) {
            return $http.post('favorites/updateitemsfavoritesgroup', { FK_UserId: favoritesGroup.userId, groupName: favoritesGroup.groupName, itemIds: favoritesGroup.itemIds});
        },
    }
}]);
